import React from "react";
import { useRecoilState } from "recoil";
import { residentialAddressState } from "../../state/QuoteState";
import SummaryItem from "../../components/SummaryItem";
import CustomDivider from "../../components/CustomDivider";

const ResidentialAddressSummary = ({ onEdit }: { onEdit: () => void }) => {
  const [{ address1, address2, address3, postalCode, suburb }] = useRecoilState(
    residentialAddressState
  );
  return (
    <>
      <SummaryItem
        items={[address1, address2, address3, postalCode, suburb]}
        onEdit={onEdit}
      >
        Address
      </SummaryItem>
    </>
  );
};

export default ResidentialAddressSummary;
